import React from 'react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import PageHeader from '../components/PageHeader';
import { TrendingUp } from 'lucide-react';
const Statistics = () => {
  return <div className="flex h-screen bg-gray-50" data-id="element-4068">
      <div className="w-20 flex-shrink-0" data-id="element-4069">
        <Sidebar data-id="element-4070" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-4071">
        <Topbar data-id="element-4072" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-4073">
          <PageHeader title="Statistiche" subtitle="Analytics e reportistica avanzata" data-id="element-4074" />

          {/* Placeholder */}
          <div className="rounded-lg border border-gray-200 bg-white p-12" data-id="element-4075">
            <div className="text-center" data-id="element-4076">
              <TrendingUp className="h-16 w-16 text-gray-300 mx-auto mb-4" data-id="element-4077" />
              <h2 className="text-xl font-semibold text-gray-700 mb-2" data-id="element-4078">
                Statistiche
              </h2>
              <p className="text-gray-500 max-w-md mx-auto" data-id="element-4079">
                Questa pagina conterrà statistiche avanzate. Coming soon.
              </p>
            </div>
          </div>
        </main>
      </div>
    </div>;
};
export default Statistics;